/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Routes } from '@angular/router';
import { NotFoundComponent } from 'app/shared/containers/not-found/not-found.component';
import { StyleguideComponent } from 'app/shared/containers/styleguide/styleguide.component';
import * as fromSharedGuards from './shared/guards';
import { LogoutComponent } from './shared/containers/logout/logout.component';

export const AppRoutes: Routes = [
  {
    path: '404',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  {
    path: 'styleguide',
    pathMatch: 'full',
    component: StyleguideComponent,
  },
  {
    path: '_profile',
    canActivate: [fromSharedGuards.UserGuard],
    loadChildren: () => import('app/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: '_my-account',
    canActivate: [fromSharedGuards.UserGuard],
    loadChildren: () => import('app/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'embed',
    loadChildren: () => import('app/embed/embed.module').then((m) => m.EmbedModule),
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '',
    canActivate: [fromSharedGuards.UserPreloadGuard],
    loadChildren: () => import('app/core/core.module').then((m) => m.CoreModule),
  },
];
